/**
 * finds if a given string contains another string (with optionality for case-sensitivity)
 *
 * @param container
 * @param stringToCheck
 * @param caseSensitive
 */
export const hasSubstring = (container: string, stringToCheck: string, caseSensitive = false) => {
  if (!caseSensitive) {
    container = container.toLowerCase()
    stringToCheck = stringToCheck.toLowerCase()
  }
  return container.includes(stringToCheck)
}
